import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
/**
 * Toggle switch component for boolean settings
 *
 * @example
 * ```tsx
 * <Switch
 *   id="active"
 *   label="Active"
 *   checked={isActive}
 *   onChange={(e) => setIsActive(e.target.checked)}
 * />
 * ```
 */
export const Switch = forwardRef(({ label, description, size = 'md', className = '', id, disabled, ...props }, ref) => {
    const descriptionId = description && id ? `${id}-description` : undefined;
    // Size variants
    const trackSize = size === 'sm' ? 'h-5 w-9' : 'h-6 w-11';
    const thumbSize = size === 'sm' ? 'size-4' : 'size-5';
    const switchElement = (_jsxs("label", { htmlFor: id, className: `relative inline-flex cursor-pointer items-center ${disabled ? 'cursor-not-allowed opacity-50' : ''}`, children: [_jsx("input", { ref: ref, id: id, type: "checkbox", role: "switch", "aria-describedby": descriptionId, disabled: disabled, className: "peer sr-only", ...props }), _jsx("div", { className: `${trackSize} rounded-full bg-gray-200 peer-checked:bg-primary peer-focus-visible:outline peer-focus-visible:outline-2 peer-focus-visible:outline-offset-2 peer-focus-visible:outline-primary dark:bg-white/10 dark:peer-checked:bg-primary dark:peer-focus-visible:outline-primary transition-colors duration-200 ${className}` }), _jsx("div", { className: `absolute left-0.5 top-0.5 ${thumbSize} rounded-full bg-white shadow-sm ring-1 ring-gray-900/5 transition-transform duration-200 ${size === 'sm' ? 'peer-checked:translate-x-4' : 'peer-checked:translate-x-5'}` })] }));
    if (!label) {
        return switchElement;
    }
    return (_jsxs("div", { className: "flex items-start gap-3", children: [switchElement, _jsxs("div", { className: "flex flex-col", children: [_jsx("span", { className: `text-sm font-medium text-foreground ${disabled ? 'opacity-50' : ''}`, children: label }), description && (_jsx("span", { id: descriptionId, className: "text-sm text-gray-500 dark:text-gray-400", children: description }))] })] }));
});
Switch.displayName = 'Switch';
//# sourceMappingURL=Switch.js.map